// @flow
import Carousel from '../ImageAndText';

const dfImage = '/images/diamond-education/colorless.gif';
const gjImage = '/images/diamond-education/near_colorless.gif';
const kmImage = '/images/diamond-education/faint_color.gif';
const nrImage = '/images/diamond-education/vlight_color.gif';
const szImage = '/images/diamond-education/light_color.gif';

const items = [
  {
    headerText: 'Colorless',
    text: `<p>While there are differences in color between D, E, and F diamonds, they can be detected only by a gemologist
      in side by side comparisons, and rarely by the untrained eye. </p>
      <p>D-F diamonds should only be set in white gold / platinum. Yellow gold reflects color, negating the diamond's
      colorless effect.</p>`,
    imageUrl: dfImage,
    imageLocation: 'top',
    imageAlt: 'D-F Diamond Color Scale',
    imageStyles: {
      margin: 20,
      marginTop: 26,
      marginBottom: 0,
      height: 54,
      width: 213
    }
  },
  {
    headerText: 'Near Colorless',
    text: `<p>While containing traces of color, G-J diamonds are suitable for a platinum or white gold setting, which
      would normally betray any hint of color in a diamond.</p>
      <p>Because I-J diamonds are more common than the higher grades, they tend to be a great value. An I-J diamond
      may retail for half the price of a D diamond. Within the G-J range, price tends to increase 10-20% between
      each diamond grade.</p>`,
    imageUrl: gjImage,
    imageLocation: 'top',
    imageAlt: 'G-J Diamond Color Scale',
    imageStyles: {
      margin: 20,
      marginTop: 26,
      marginBottom: 0,
      height: 55,
      width: 282
    }
  },
  {
    headerText: 'Faint Color',
    text: `<p>Beginning with K diamonds, color (usually a yellow tint) is more easily detected by the naked eye.</p>
      <p>Set in yellow gold, these warm colored diamonds appeal to some, and are an exceptional value. Others will
      feel they have too much color. Due to its perceptible color tint, a K diamond is often half the price
      of a G diamond.</p>`,
    imageUrl: kmImage,
    imageLocation: 'top',
    imageAlt: 'K-M Diamond Color Scale',
    imageStyles: {
      margin: 20,
      marginTop: 26,
      marginBottom: 0,
      height: 54,
      width: 213
    }
  },
  {
    headerText: 'Very Light Color',
    text: `<p>Diamonds in the N-R color range have an easily seen yellow or brown tint, but are much less expensive than higher grades.</p>
      <p>Lumera does not carry diamonds in this color range due to a lack of demand. If you desire a diamond in this range,
      <a href="/form_responders/custom_diamond_search" target="_blank">request a price quote</a> using the custom diamond search.</p>`,
    imageUrl: nrImage,
    imageLocation: 'top',
    imageAlt: 'N-R Diamond Color Scale',
    imageStyles: {
      margin: 20,
      marginTop: 26,
      marginBottom: 0,
      height: 54,
      width: 52
    }
  },
  {
    headerText: 'Light Color',
    text: `<p>For almost all customers, S-Z diamonds have too much color for a white diamond.</p>
      <p>Lumera does not carry diamonds in this color range. If you desire a diamond in this range,
      <a href="/form_responders/custom_diamond_search" target="_blank">request a price quote</a> using the custom diamond search.</p>`,
    imageUrl: szImage,
    imageLocation: 'top',
    imageAlt: 'S-Z Diamond Color Scale',
    imageStyles: {
      margin: 20,
      marginTop: 26,
      marginBottom: 0,
      height: 55,
      width: 52
    }
  }
];

const GradingDiamondCut = (props: Object) => {
  return (
    <Carousel {...props} items={items} contentStyles={{ minHeight: 248 }} />
  );
};

export default GradingDiamondCut;
